import MembersGroupUserName from "./MembersGroupUserName";
import MembersGroupUserLink from "./MembersGroupUserLink";


import MembersGroupName from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupName";
import MembersGroupLink from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupLink";

import UserName from "../../../../auth/components/user/UserDetail/UserName";
import UserLink from "../../../../auth/components/user/UserDetail/UserLink";
import { toStringDisplay as toStringGroupType } from "../../../types/models/GroupType.d";

import {NavLink, useParams} from "react-router";
import Refresh from "@mui/icons-material/Refresh";
import Clear from "@mui/icons-material/Clear";
import Grid from '@mui/material/Grid';
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const MembersGroupUserDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" justifyContent="left" spacing={1}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="MembersGroupUser-detail-title"
                    >
                        { label || t`Members Group User` }: <MembersGroupUserName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" justifyContent="right" spacing={1}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="MembersGroupUser-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="MembersGroupUser-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="membersGroupId-label"><Trans>Members Group</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="membersGroupId-value" >{ data.membersGroupId ? (<MembersGroupLink id={ data.membersGroupId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="ownedMembersGroupId-label"><Trans>User</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="ownedMembersGroupId-value" >{ data.ownedMembersGroupId ? (<UserLink id={ data.ownedMembersGroupId }/>) : '-' }</Grid>
                    
            </Grid>
        </Stack>
    )
}

export default MembersGroupUserDetail;
